import { useTLang } from 'intl/intl';

export function useMenuItemFinderLang() {
  const langClean = useTLang({ id: 'substitutionFlow.039' });
  return {
    header: {
      title: useTLang({ id: 'substitutionFlow.037' }),
    },
    main: {
      title: useTLang({ id: 'substitutionFlow.038' }),
    },
    input: {
      first: {
        placeholder: useTLang({ id: 'substitutionFlow.011' }),
        clean: langClean,
      },
      second: {
        placeholder: useTLang({ id: 'substitutionFlow.012' }),
        clean: langClean,
      },
    },
  };
}
